/**
 * Pages de compte servies sans session : activation d'une invitation,
 * réinitialisation du mot de passe (le jeton de l'adresse fait foi) et fiche du
 * comptable invité (session d'une autre entreprise ou jeton de compte). L'écran
 * de connexion interne reste dans `App.tsx` (repli de toute adresse inconnue).
 */
import { lazy } from 'react';
import type { ExternalRoute } from '../../app/route-types.js';

const InvitationPage = lazy(() => import('./InvitationPage.js').then((m) => ({ default: m.InvitationPage })));
const ResetPasswordPage = lazy(() => import('./ResetPasswordPage.js').then((m) => ({ default: m.ResetPasswordPage })));
const AccountantProfilePage = lazy(() => import('./AccountantProfilePage.js').then((m) => ({ default: m.AccountantProfilePage })));

export const authRoutes: ExternalRoute[] = [
  { path: '/invitation', element: <InvitationPage /> },
  { path: '/reinitialisation', element: <ResetPasswordPage /> },
  // Fiche du comptable invité (25/10/2026) : sur son compte, hors d'une entreprise.
  { path: '/compte/comptable', element: <AccountantProfilePage /> },
];
